<template>
  <b-modal
    id="date-modal"
    hide-footer
    hide-header
    centered
    size="lg"
    content-class="text-center bg-light styled-modal centered pr-4 pl-4"
  >
    <div class="row centered-content">
      <div class="col-12 col-lg-6 m-auto">
        <h4
          class="new-modal-title mb-3"
          v-html="$t('lang.search.dates.calendar_title')"
        />
        <v-calendar
          :locale="$store.state.main.lang"
          :attributes="attributes"
          :min-date="now"
          :max-date="maxDate"
          color="pink"
          day-disabled="pointer-events: none"
          is-expanded
          @dayclick="onDayClick"
        />
      </div>
    </div>
    <div class="row justify-content-center mt-3">
      <div class="col-12 col-lg-6 d-flex flex-row justify-content-between ">
        <!-- HORARIO INGRESO -->
        <div class="text-left">
          <h6 for="start-hour">
            {{ $t('lang.search.dates.start_hour') }}
            <b-link
              v-b-popover.top.click.blur.html="$t('lang.search.dates.hours_popover_info')"
              class="question-link d-inline-block small"
            >
              <i class="icon-question" />
            </b-link>
          </h6>
          <div class="btn-group dropup p-0 text-left">
            <button
              id="start-hour"
              type="button"
              class="btn btn-light active dropdown-toggle p-2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              {{ formatHour12(startHour) }}
            </button>
            <div
              class="dropdown-menu pre-scrollable prices-dropdown"
              style="max-height: 300px;"
            >
              <button
                v-for="i in startHoursList"
                :key="'start_hour_'+i"
                class="dropdown-item"
                type="button"
                @click="selectedHour(i, 'start')"
              >
                <span :class="[i===startHour ? 'color_text' : '', 'font-weight-bold']">
                  {{ formatHour12(i) }}
                </span>
              </button>
            </div>
          </div>
        </div>

        <!-- HORARIO SALIDA -->
        <div class="text-right">
          <h6 for="end-hour">
            {{ $t('lang.search.dates.end_hour') }}
            <b-link
              v-b-popover.top.click.blur.html="$t('lang.search.dates.hours_popover_info')"
              class="question-link d-inline-block small"
            >
              <i class="icon-question" />
            </b-link>
          </h6>
          <div class="btn-group dropup p-0 text-left">
            <button
              id="end-hour"
              type="button"
              class="btn btn-light active dropdown-toggle p-2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              {{ formatHour12(endHour) }}
            </button>
            <div
              class="dropdown-menu pre-scrollable prices-dropdown"
              style="max-height: 300px;"
            >
              <button
                v-for="i in endHoursList"
                :key="'end_hour_'+i"
                class="dropdown-item"
                type="button"
                @click="selectedHour(i, 'end')"
              >
                <span :class="[i===endHour ? 'color_text' : '', 'font-weight-bold']">
                  {{ formatHour12(i) }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 m-lg-3 text-right mt-4">
        <button
          id="btn_submit"
          type="submit"
          class="btn w-100 btn-main-color p-1"
          name="btn_submit"
          @click="closeModal()"
        >
          {{ $t('lang.search.dates.confirm') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { getDefaultSearchDates } from '@/utils/dateFormatters';

export default {
  name: 'DatePickerModal',
  data() {
    return {
      days: [],

      startHour: '',
      endHour: '',

      now: new Date(),
      maxDate: new Date().setMonth(new Date().getMonth() + 3),

      range: {
        start: new Date(),
        end: new Date(),
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },

    };
  },
  computed: {
    attributes() {
      const attrs = [
        {
          highlight: {
            start: { fillMode: 'solid' },
            base: { fillMode: 'light' },
            end: { fillMode: 'solid' },
          },
          dates: this.range,
        },
      ];
      return attrs;
    },

    startHoursList() {
      const list = [];
      let minHour = 1;

      const start = this.range.start.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });
      const now = this.now.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });

      if (start === now) {
        minHour = this.now.getHours();
      }

      for (let i = minHour; i < 24; i++) {
        list.push(i);
      }
      return list;
    },

    endHoursList() {
      const list = [];
      let minHour = 0;

      const start = this.range.start.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });
      const end = this.range.end.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });

      if (start === end) {
        minHour = this.startHour;
        minHour++;
      }

      for (let i = minHour; i < 24; i++) {
        list.push(i);
      }

      return list;
    },
  },

  created() {
    // Si hay fechas ya guardadas en store toma esas.
    if (this.$store.state.search.searchParams != null) {
      const storeStartDate = this.$store.state.search.searchParams.input_start_date;
      const storeEndDate = this.$store.state.search.searchParams.input_end_date;

      this.range = {
        start: new Date(storeStartDate),
        end: new Date(storeEndDate),
      };
      this.startHour = new Date(storeStartDate).getHours();
      this.endHour = new Date(storeEndDate).getHours();
    } else {
      const {
        startDate,
        endDate,
        startHour,
        endHour,
      } = getDefaultSearchDates();

      this.range = {
        start: startDate,
        end: endDate,
      };
      this.startHour = startHour;
      this.endHour = endHour;
    }

    const dates = this.getSelectedDates();
    this.$emit('datesSelected', dates.startDate, dates.endDate);
  },

  methods: {

    formatHour12(hour) {
      let newHour = new Date();
      newHour = newHour.setHours(hour, '00', '00');
      newHour = new Date(newHour);
      // Usamos en-US para que muestre AM o PM. En otros idiomas se muestra feo.
      return newHour.toLocaleString('en-US', { hour: 'numeric', hour12: true });
    },

    onDayClick(day) {
      // Se llama cada vez que tocan un día en el calendario.
      // Si tocan un día, el range es de ese sólo día. La reserva sería por un día.
      // Si tocan un segundo día, el range se arma desde el día más pronto al día más lejano.
      // Si tocan un tercer día y ya había un rango de dos días, se resetea el rango y toma sólo ese día.
      if (this.days.length === 2) {
        // Tocaron un día más, pero ya había un rango formado de 2 días,
        // reinicia el rango a sólo el día seleccionado ahora.
        this.days = [{
          id: day.id,
          date: day.date,
        }];
        this.range = {
          start: this.days[0].date,
          end: this.days[0].date,
        };
      } else if (this.days.length === 1) {
        // Eligieron un segundo día, hacer un rango. El range se arma desde el día más pronto al día más lejano.
        if (this.days[0].date !== day) {
          this.days.push({
            id: day.id,
            date: day.date,
          });

          // Compara para saber cuál es el inicio y fin del rango.
          if (this.days[0].date < this.days[1].date) {
            this.range = {
              start: this.days[0].date,
              end: this.days[1].date,
            };
          } else {
            this.range = {
              start: this.days[1].date,
              end: this.days[0].date,
            };
          }
        }
      } else {
        // Eligieron un sólo día. Start y end es el mismo día.
        this.days = [{
          id: day.id,
          date: day.date,
        }];
        this.range = {
          start: this.days[0].date,
          end: this.days[0].date,
        };
      }

      // Si el primer día es hoy, la hora seleccionada debe ser la mínima disponible.
      // Sino quedaría seleccionada una hora si estaba seleccionado otro día y volvía a hoy
      const start = this.range.start.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });
      const now = this.now.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
      });

      if (start === now) {
        this.startHour = new Date().getHours() + 1;
      }
    },

    selectedHour(hour, option) {
      if (option === 'start') {
        this.startHour = hour;

        let newEndHour = hour + 8;
        if (newEndHour < 18) {
          newEndHour = 18;
        } else if (newEndHour > 23) {
          newEndHour = 23;
        }
        this.endHour = newEndHour;
      } else {
        this.endHour = hour;
      }
    },

    getSelectedDates() {
      let startDate = this.range.start;
      let endDate = this.range.end;

      startDate = new Date(startDate.setHours(this.startHour, '00', '00'));
      endDate = new Date(endDate.setHours(this.endHour, '00', '00'));
      return { startDate, endDate };
    },

    closeModal() {
      const dates = this.getSelectedDates();
      this.$emit('datesSelected', dates.startDate, dates.endDate);
      this.$bvModal.hide('date-modal');
    },
  },

};
</script>

<style scoped>

</style>
